<ng-template #templateRef>
    <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="locationEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} Group {{Copy.Title}}
          <app-creator-modifier-icon style="float: right; margin-right: 10px" [object]="Copy"></app-creator-modifier-icon></h2>
        <mat-dialog-content *ngIf="Copy">
            <mat-tab-group>
                <mat-tab label="Algemeen">
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Title</mat-label>
                                <input matInput name="Title" [(ngModel)]="Copy.Title"
                                       required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field>
                              <mat-label>Description</mat-label>
                                <textarea matInput name="Description" [(ngModel)]="Copy.Description"></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>Start date</mat-label>
                                <input matInput name="Start"
                                       [(ngModel)]="Copy.Start" [matDatepicker]="picker1">
                                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1 [startAt]="Copy.Start "></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-md-6">
                            <mat-form-field>
                              <mat-label>End date</mat-label>
                                <input matInput name="End"
                                       [(ngModel)]="Copy.End " [matDatepicker]="picker2">
                                <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2 [startAt]="Copy.End "></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Relations">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-right">
                                <button mat-icon-button type="button" (click)="rEditor.open(Copy.Relations)">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                  <mat-list style="width: 100%">
                    <mat-list-item *ngFor="let rel of Copy.Relations" class="list-item">
                      <h4 matListItemTitle>{{rel.Name}}</h4>
                      <p matListItemLine>{{rel.DefaultAddress?.getFullAddress()}}</p>
                      <button mat-icon-button type="button" matListItemMeta appConfirmDialog (confirm)="removeRelation(rel)">
                        <mat-icon class="delete-icon">delete</mat-icon>
                      </button>
                    </mat-list-item>
                  </mat-list>
                </mat-tab>
                <mat-tab label="Articles">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-right">
                                <button mat-icon-button type="button" (click)="aEditor.open(Copy.Articles)">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <mat-list style="width: 100%">
                            <mat-list-item *ngFor="let art of Copy.Articles" class="list-item">
                                <h4 matListItemTitle>{{art.CommercialName}}</h4>
                                <p matListItemLine>{{art.Code}}</p>
                                <button mat-icon-button type="button" class="text-right" matListItemMeta appConfirmDialog (confirm)="removeArticle(art)">
                                    <mat-icon class="delete-icon">delete</mat-icon>
                                </button>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </mat-tab>
                <mat-tab label="Promotions">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="text-right">
                                <button mat-icon-button type="button" (click)="pEditor.open(Copy.Promotions)">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                      <mat-list style="width: 100%">
                          <mat-list-item *ngFor="let promotion of Copy.Promotions" class="list-item">
                            <h4 matListItemTitle>{{promotion.getTitle()}}</h4>
                            <p matListItemLine>{{promotion.StartDate | date: 'shortDate'}} - {{promotion.EndDate | date: 'shortDate'}}</p>
                            <button mat-icon-button type="button" class="text-right" matListItemMeta appConfirmDialog (confirm)="removePromotion(promotion)">
                              <mat-icon class="delete-icon">delete</mat-icon>
                            </button>
                          </mat-list-item>
                        </mat-list>
                    </div>
                </mat-tab>
              <mat-tab label="Promotion Codes">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="text-right">
                      <button (click)="pcEditor.open(Copy.PromotionCodes)" mat-icon-button type="button">
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <mat-list style="width: 100%">
                    <mat-list-item *ngFor="let code of Copy.PromotionCodes" class="list-item">
                      <h4 matListItemTitle>{{code.Code}}</h4>
                      <h4 matListItemTitle>{{code.getDescription()}}</h4>
                      <p matListItemLine>{{code.StartDate | date: 'shortDate'}} - {{code.EndDate | date: 'shortDate'}}</p>
                      <button (confirm)="removeCode(code)" matListItemMeta appConfirmDialog class="text-right" mat-icon-button type="button">
                        <mat-icon class="delete-icon">delete</mat-icon>
                      </button>
                    </mat-list-item>
                  </mat-list>
                </div>
              </mat-tab>
            </mat-tab-group>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>

<app-article-picker #aEditor [(List)]="Copy.Articles"></app-article-picker>
<app-relation-picker #rEditor [(List)]="Copy.Relations"></app-relation-picker>
<app-promotion-picker #pEditor [(List)]="Copy.Promotions"></app-promotion-picker>
<app-promotion-code-picker #pcEditor [(List)]="Copy.PromotionCodes"></app-promotion-code-picker>
